<app-modal [header]="'Reportar ocorrencia'"
           [isShow]="displayModal"
           [style]="'w-full max-w-lg'"
           (cancel)="displayModal = false; onCancelModalEmitter.emit()">

  <p class="text-xs">Na existência de alguma irregularidade como erros de informação, imagens explícitas,
    ocorrência duplicada ou já resolvida, utilize o campo abaixo para informar nossa equipe.</p>

  <div class="mt-10">
    <form [formGroup]="form" class="text-blueGray-700" (ngSubmit)="onSubmit()">

      <div>
        <app-text-area-input [formGroup]="form" id="description" [rows]="4" placeholder="Descrição"
          label="Descrição (Obrigatório)" [maxLength]="500" [formError]="formDescriptionFieldErro"
          [resizeable]="false">
        </app-text-area-input>

        <div class="mt-6 flex justify-end">
          <app-ae-button variant="primary" label="Reportar" icon="pi pi-send" type="submit" size="sm" styleClass="text-xs"></app-ae-button>
        </div>
      </div>

    </form>
  </div>

</app-modal>
